import qs from 'qs'
import axios from './../index'

/**
 * @description 特价专区
 * http://192.168.2.177:3000/project/21/interface/api/1755
 * @author txw
 * @date 2020-07-17
 * @export
 */
export function requestSpeciallist (params) {
  return axios.post('/product/loadspeciallist', qs.stringify(params))
}
